import React, {useState} from 'react';
import styled from 'styled-components/native';
import { View, Text, Pressable } from 'react-native';
import { Link } from 'app/src/utils/routing';
import { elLightGray } from '../../../styles/colors';
import { useLocation } from 'react-router-dom';
import Modal from '../../../elements/Modal';
import NewUser from './new';
import { SubNavContainer } from '../../../elements';

// const NavbarContainer = styled(View)`
//   display: flex;
//   flex-direction: row;
//   justify-content: space-between;
//   flex: 0.25;
//   align-items: center;
//   height: 5px;
//   background-color: ${elLightGray};
//   padding: 15px;
//   padding-left: 50px;
// `;

const SubNav = ({user, refetch}) => {
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const location = useLocation();
  return (
    <SubNavContainer>
      {getLinks()}
    </SubNavContainer>
  )

  function getLinks() {
    if(location.pathname === '/users') {
      return (
        <View>
          <Pressable
            onPress={() => setShowAddUserModal(true)}
          >
            <Text>+ Add User</Text>
          </Pressable>
          {showAddUserModal &&
            <Modal
              setShowModal={setShowAddUserModal}
              modalType={'Add User'}
            >
              <NewUser
                setShowModal={setShowAddUserModal}
                refetch={refetch}
              />
            </Modal>
          }
        </View>
      )
    }else if(location.pathname === '/Users/new') {
      return (
        <Link to={`/users`}>
          <Text>Users</Text>
        </Link>
      )
    }else {
      return (
        <Link to={`/users/new`}>
          <Text>+ Add User</Text>
        </Link>
      )
    }
  }
}

export default SubNav;
